module.exports = __webpack_public_path__ + "img/swift-sport-blanco-pop.72bf82f2.png";